import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-3 p-3 w-full" }
const _hoisted_2 = {
  key: 0,
  class: "message"
}
const _hoisted_3 = {
  key: 1,
  class: "description"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = { class: "space-x-2 flex justify-end" }

import BaseModal from '@/components/modals/BaseModal';
import { useModalControls } from './hooks/use-modal-controls';
import { computed, ref } from 'vue';
import Button from '@ui-kit/controls/button/Button.vue';
import { ButtonColors } from '@ui-kit/controls/button/types';

interface Props {
  title?: string;
  message?: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
  danger?: boolean;
  success?: boolean;
  confirm(): Promise<void>|void;
  confirmationDisableTime?: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalConfirmation',
  props: {
    title: null,
    message: null,
    description: null,
    confirmText: null,
    cancelText: null,
    danger: { type: Boolean },
    success: { type: Boolean },
    confirm: null,
    confirmationDisableTime: null
  },
  setup(__props: any) {

const props = __props as {
  title?: string;
  message?: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
  danger?: boolean;
  success?: boolean;
  confirm(): Promise<void>|void;
  confirmationDisableTime?: number;
}



const pending = ref<boolean>(false);
const { close } = useModalControls();
function confirm() {
  const promise = props.confirm();
  if (promise instanceof Promise) {
    pending.value = true;
    promise.then(() => {
      close();
    }).finally(() => {
      pending.value = false;
    });
  } else {
    close();
  }
}

const confirmButtonColor = computed<ButtonColors>(() => {
  switch (true) {
    case props.danger: return 'danger';
    case props.success: return 'success';
    default: return 'primary';
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseModal), {
    size: "lg",
    "hide-header": !__props.title,
    title: __props.title,
    "hide-close-button": "",
    "no-body-padding": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (__props.message || __props.description)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (__props.message)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.message), 1))
                : _createCommentVNode("", true),
              (__props.description)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.description), 1))
                : _createCommentVNode("", true),
              _hoisted_4
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(Button, {
            "button-type": "outline",
            label: __props.cancelText ? __props.cancelText : _ctx.$t('common.actions.cancel'),
            onClick: _unref(close)
          }, null, 8, ["label", "onClick"]),
          _createVNode(Button, {
            loading: pending.value,
            color: _unref(confirmButtonColor),
            label: __props.confirmText ? __props.confirmText : _ctx.$t('common.actions.confirm'),
            "disable-time": __props.confirmationDisableTime,
            onClick: confirm
          }, null, 8, ["loading", "color", "label", "disable-time"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["hide-header", "title"]))
}
}

})